import React, { useState } from 'react';
import { Users, Building2, MapPin, Mail, Tags, Menu, X, LogOut, Inbox, Bot, ClipboardList, Route } from 'lucide-react';

const NAV = [
  { id: 'leads', label: 'Guest Leads', icon: Users },
  { id: 'businesses', label: 'Business Intakes', icon: Building2 },
  { id: 'places', label: 'Card Workbench', icon: MapPin },
  { id: 'launch_triage', label: 'Launch Triage', icon: ClipboardList },
  { id: 'composer', label: 'Composer Preview', icon: Route },
  { id: 'guest_day_slide', label: 'Day Slide Fixture', icon: Route },
  { id: 'changes', label: 'Change Proposals', icon: Inbox },
  { id: 'agents', label: 'Agent Workbench', icon: Bot },
  { id: 'subscribers', label: 'Subscribers', icon: Mail },
  { id: 'taxonomy', label: 'Taxonomy', icon: Tags },
];

const Sidebar = ({ activeTab, setActiveTab, onLogout }) => {
  const [open, setOpen] = useState(true);

  return (
    <div className={`${open ? 'w-56' : 'w-14'} bg-slate-800 text-white flex flex-col h-full transition-all duration-200 flex-shrink-0`}>
      {/* Logo / toggle */}
      <div className="p-3 border-b border-slate-700 flex items-center justify-between h-14">
        {open && <span className="text-sm font-semibold tracking-wide text-slate-200">Pocket Host</span>}
        <button onClick={() => setOpen(o => !o)} className="p-1.5 rounded hover:bg-slate-700 ml-auto">
          {open ? <X className="w-4 h-4" /> : <Menu className="w-4 h-4" />}
        </button>
      </div>

      {/* Nav */}
      <nav className="flex-1 p-2 space-y-1 overflow-y-auto">
        {NAV.map(({ id, label, icon: Icon }) => {
          const badge = null;
          return (
          <button
            key={id}
            onClick={() => setActiveTab(id)}
            className={`w-full flex items-center gap-3 px-3 py-2 rounded-lg text-sm transition-colors ${
              activeTab === id ? 'bg-blue-600 text-white' : 'text-slate-300 hover:bg-slate-700 hover:text-white'
            }`}
          >
            <Icon className="w-4 h-4 flex-shrink-0" />
            {open && (
              <>
                <span className="flex-1 text-left">{label}</span>
                {badge > 0 && (
                  <span className="min-w-5 px-1.5 py-0.5 text-[11px] font-semibold rounded-full bg-orange-500 text-white">
                    {badge}
                  </span>
                )}
              </>
            )}
          </button>
          );
        })}
      </nav>

      {/* Logout */}
      <div className="p-2 border-t border-slate-700">
        <button
          onClick={onLogout}
          className="w-full flex items-center gap-3 px-3 py-2 rounded-lg text-sm text-slate-400 hover:bg-slate-700 hover:text-white transition-colors"
          title="Logout"
        >
          <LogOut className="w-4 h-4 flex-shrink-0" />
          {open && <span>Logout</span>}
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
